import { Component, OnInit, Optional, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "app-dialog-box",
  templateUrl: "./dialog-box.component.html",
  styleUrls: ["./dialog-box.component.scss"]
})
export class DialogBoxComponent implements OnInit {
  public action: string;
  public local_data: any;
  public msg: string;

  constructor(
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    //@Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.msg = data.msg;
    this.action = data.action;
    delete data.msg;
    delete data.action;
    this.local_data = Object.assign({}, data);
    let date = new Date(this.local_data.date);
    this.local_data.date = `${date.getMonth() +
      1}/${date.getDate()}/${date.getFullYear()}`;
  }

  doAction() {
    this.dialogRef.close({ event: this.action, data: this.data });
  }

  closeDialog() {
    this.dialogRef.close({ event: "Cancel" });
  }

  ngOnInit() {}
}
